import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { initialState } from "./state";
import { IncomingMessage } from "../types/IncomingMessage";
import { InvokeCall } from "../types/InvokeCall";

const sendMessageAsync = createAsyncThunk(
    "messages/sendMessageAsync",
    async (payload: InvokeCall, thunkApi) => {
        thunkApi.dispatch(
            messagesSlice.actions.__private__queueCallToInvoke(payload),
        );
        thunkApi.dispatch(
            messagesSlice.actions.__private__scheduleNextInvokeCall({
                completeCurrentPendingInvokeCall: false,
            }),
        );
    },
);

const completePendingInvokeCallAsync = createAsyncThunk(
    "messages/completePendingInvokeCallAsync",
    async (payload: undefined, thunkApi) => {
        thunkApi.dispatch(
            messagesSlice.actions.__private__scheduleNextInvokeCall({
                completeCurrentPendingInvokeCall: true,
            }),
        );
    },
);

// slice
export const messagesSlice = createSlice({
    name: "messages",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        messageReceived: (state, action: PayloadAction<IncomingMessage>) => {
            // empty reducer needed to generate action used in listeners.ts files
        },
        __private__queueCallToInvoke: (
            state,
            action: PayloadAction<InvokeCall>,
        ) => {
            state.callsToInvoke.push(action.payload);
        },
        __private__scheduleNextInvokeCall: (
            state,
            action: PayloadAction<{
                completeCurrentPendingInvokeCall: boolean;
            }>,
        ) => {
            if (
                action.payload.completeCurrentPendingInvokeCall ||
                !state.pendingInvokeCall
            ) {
                state.pendingInvokeCall = state.callsToInvoke?.shift();
            }
        },
    },
});

// exports
export const messagesThunks = {
    sendMessageAsync,
    completePendingInvokeCallAsync,
};
export const messagesActions = {
    ...messagesSlice.actions,
    __private__queueCallToInvoke: undefined,
    __private__scheduleNextInvokeCall: undefined,
};

export default messagesSlice.reducer;
